export default __webpack_public_path__ + "static/media/Comfortaa-Regular.5fe41777.ttf";